import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';

import Navbar from '../sections/main_page/Navbar';
import Presale from '../sections/main_page/Presale';
import Footer from '../sections/main_page/Footer';


const useStyles = makeStyles((theme) => {
    return {
      root: {
          flexGrow: 1
      }
    }
  });
  
  function Main() {
      const classes = useStyles();
      return (
          <div className={ classes.root }>
            <Navbar/>
            <Presale/>
            <Footer/>
          </div>    
      );
    }
    
  export default Main;